namespace Teva {
    export class Navigation {
        static IsNewWindowEvent(Event) {
            return Event.ctrlKey || Event.shiftKey || Event.metaKey;
        }

        static FocusOnFirstField(Container = null, OnlyWhenVisible = false): boolean {
            var FirstField;
            if (Container == null)
                Container = "#main-inner";
            FirstField = $(":input:visible:enabled:not([type=button]):not([type=submit]):not([disabled]):not(.teva-dropdown-link):not(.teva-dropdown-menu-item):not(.crm-entities-field-link):not(.form-hidden-submit):not(.og-preventautofocus):first, a:visible:not([tabindex=-1]):not(.teva-dropdown-menu-item):not(.og-preventautofocus):first, div.og-richtexteditor:visible", Container).first();
            if (FirstField.length == 0)
                FirstField = $(":focusable:not([disabled]):not(.teva-dropdown-link):not(.teva-dropdown-menu-item):not(.crm-entities-field-link):not(.form-hidden-submit):not([tabindex=-1]):not(.og-preventautofocus):visible:first", Container);
            if (FirstField.length == 0)
                return false;

            if (OnlyWhenVisible && $(window).height() < FirstField.offset().top)
                return false;

            if (FirstField.hasClass("datepicker") || FirstField.hasClass("timepicker") || FirstField.hasClass("datetimepicker") || FirstField.hasClass("monthpicker"))
                FirstField.data("datepicker-ignoreevent", true).trigger("focus");
            else
                FirstField.trigger("focus");
            $(".tooltip").remove();
            return true;
        }
    }
}